import React from 'react'
import './pageNotFound.css'

function C2wPageNotFound() {
  return (
    <div className='C2wPageNotFound_ctn'>
        <div className='C2wPageNotFound_text_ctn'>
            <div>{'404'}</div>
            <div>{'Page Not Found'}</div>
        </div>
        <div className='C2wPageNotFound_logo_ctn'>
            <img src='/assets/images/pagenotfound/pageNotFoundAsset.png' alt='pageNotFoundBg' />
        </div>
    </div>
  )
}

export default C2wPageNotFound
